// Where the wall clock goes while a run opens. Marks are milliseconds on the page's
// clock; the worker has a time origin of its own and is told the page's so its marks
// land on the same line. main.js prints the differences once the first frame is up.

export const marks = [];
let shift = 0;

// The worker calls this with the page's timeOrigin before its first mark.
export function alignTo(pageOrigin) { shift = performance.timeOrigin - pageOrigin; }

export function mark(name) { marks.push([name, performance.now() + shift]); }

export function takeMarks() { const out = marks.slice(); marks.length = 0; return out; }

// [name, ms since the previous mark], in time order, with 0 as the page's start.
export function phases(ms) {
  const sorted = [...ms].sort((a, b) => a[1] - b[1]);
  let prev = 0;
  return sorted.map(([n, t]) => { const d = t - prev; prev = t; return [n, d]; });
}
